"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCreateConversation = function SvgCreateConversation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 13"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    strokeLinecap: "round",
    d: "m7 1.523 5.931 5 6.069-5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#007AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 3h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.4v1H0v-1z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#007AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.022.523H19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.708.523H7a1 1 0 0 0-1 1V3"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCreateConversation);
var _default = exports["default"] = Memo;